import { render, staticRenderFns } from "./addUser.vue?vue&type=template&id=bc663c30&"
import script from "./addUser.vue?vue&type=script&lang=js&"
export * from "./addUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc663c30')) {
      api.createRecord('bc663c30', component.options)
    } else {
      api.reload('bc663c30', component.options)
    }
    module.hot.accept("./addUser.vue?vue&type=template&id=bc663c30&", function () {
      api.rerender('bc663c30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/auth/subaccount/components/addUser.vue"
export default component.exports